<template>
  <div class="background">
    <div class="modal">
      <slot/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FullScreenModal',
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/colors.scss';

.modal {
  background-color: $white;
  display: flex;
  height: 100%;
  width: 100%;
  padding: 20px;
  position: fixed;
}

</style>
